import { createI18n } from 'vue-i18n'
import en from './en'
import es from './es'
import pl from './pl'
import {getDefaultLang} from '@/utils/tool'
const i18n = createI18n({
  legacy: false,
  locale: getDefaultLang(),
  fallbackLocale: 'en',
  messages: {
    en,
    pl,
    es

  },
})

export default i18n
